/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ProductBulkAction = typeof ProductBulkAction[keyof typeof ProductBulkAction];


export const ProductBulkAction = {
  reconcile_asset_downloads: 'reconcile_asset_downloads',
  reconcile_transcoding: 'reconcile_transcoding',
  reconcile_asset_publish: 'reconcile_asset_publish',
  requeue_import: 'requeue_import',
} as const;
